import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasOtherButtons, setHasOtherButtons] = useState(false);

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Check if there are other fixed buttons in the bottom-right area
  useEffect(() => {
    const checkForOtherButtons = () => {
      // Check for any fixed buttons in bottom-right that might overlap
      const otherFixedButtons = document.querySelectorAll('.fixed.bottom-6.right-6, .fixed.bottom-4.right-4');
      setHasOtherButtons(otherFixedButtons.length > 0);
    };

    // Initial check
    checkForOtherButtons();

    // Check periodically for dynamic buttons
    const interval = setInterval(checkForOtherButtons, 500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className={`fixed ${hasOtherButtons ? 'bottom-24' : 'bottom-8'} right-8 z-50 p-3 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300 hover:scale-110`}
          aria-label="Nach oben scrollen"
          title="Nach oben"
        >
          <ChevronUp className="w-6 h-6" />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
